import React, { useState, useEffect } from "react";

// image improt
import ic_facebook from "image/icon/ic_facebook.svg";
import ic_instagram from "image/icon/ic_instagram.svg";

// firebase
import firebase from "library/firebase-config.js";
import "firebase/firestore";
import { DATA_EMAIL } from "../items/ContactEmail";
var db = firebase.firestore();

const LINK_FACEBOOK = "https://www.facebook.com/donggubat/";
const LINK_INSTAGRAM = "https://www.instagram.com/donggubat_story/";

const Footer = () => {
	const [logoURL, setLogoUrl] = useState();

	const _getLogoUrl = () => {
		db.collection("home")
			.doc("logos")
			.get()
			.then((doc) => {
				doc.data().items.forEach((element) => {
					if (element.label === "푸터 로고") {
						setLogoUrl(element.contents[0].url);
					}
				});
			});
	};

	useEffect(() => {
		_getLogoUrl();
	}, []);

	return (
		<footer>
			<div className="con">
				<div className="footer-logo">{logoURL ? <img src={logoURL} alt="logo" /> : ""}</div>

				<div className="footer-contents">
					{/* <nav>
						<ul className="wrap-footer-nav">
							<li>
								<Link to="/about">회사소개</Link>
							</li>
							<li>
								<Link to="/service">OEM/ODM 문의</Link>
							</li>
							<li>
								<Link to="/customer">고객센터</Link>
							</li>
							<li>
								<Link to="/">이용약관</Link>
							</li>
							<li>
								<Link to="/">개인정보처리방침</Link>
							</li>
						</ul>
					</nav> */}
					<div className="footer-business">
						<div className="business-col">
							<DrawBusinessList title="사업자등록번호" text="114-87-23152" />
							<DrawBusinessList title="통신판매업신고번호" text="제 2016-서울성동-00899호" />
							<DrawBusinessList title="개인정보보호책임자" text="박상재" />
						</div>

						<div className="business-col">
							<DrawBusinessList title="대표 번호" text="070-4282-9626" />
							<DrawBusinessList title="근무시간" text="월~금 9:00-16:00 (점심시간 12:30-13:30)" />
							<DrawBusinessList title="이메일" data={DATA_EMAIL} className="email" />
						</div>
					</div>
					<div className="footer-bottom">
						<div className="wrap-sns">
							<div className="list-sns">
								<a href={LINK_FACEBOOK} rel="noopener noreferrer" target="_blank">
									<img src={ic_facebook} alt="facebook" />
								</a>
							</div>

							<div className="list-sns">
								<a href={LINK_INSTAGRAM} rel="noopener noreferrer" target="_blank">
									<img src={ic_instagram} alt="instagram" />
								</a>
							</div>
						</div>
						<p>Copyright ©Donggubat.inc All rights reserved.</p>
					</div>
				</div>
			</div>
		</footer>
	);
};

const DrawBusinessList = (props) => {
	return (
		<div className={`business-list ${props.className || ""}`}>
			<h6>{props.title}</h6>
			{props.data ? (
				<ul className="email">
					{props.data.map((email, index) => {
						return (
							<li className="email-list" key={index}>
								<p className="text-key">{email.keyText}</p>
								<p className="text-value">
									<a href={`mailto:${email.valueText}`}>{email.valueText}</a>
								</p>
							</li>
						);
					})}
				</ul>
			) : (
				<p> {props.text}</p>
			)}
		</div>
	);
};

export default Footer;
